const positions = [
  {
    position: 'manager',
    positionName: 'Менеджер'
  },
  {
    position: 'secretary',
    positionName: 'Секретарь'
  },
  {
    position: 'seniorEngineer',
    positionName: 'Старший инженер'
  },
  {
    position: 'juniorEngineer',
    positionName: 'Младший инженер'
  },
  {
    position: 'developer',
    positionName: 'Разработчик'
  },
];

export default positions;